<template>
  <!-- @FIXME: 很多 slot 相關問題，但可運作。 Ian -->
  <el-popover
    :placement="placement"
    :trigger="trigger"
    popper-class="popoverSuggestion"
    :visible-arrow="visibleArrow"
    >
    <!-- 這邊應有一個隱含的 default slot (沒給 name 的 slot) 用來給 popover 內容，
    但不能寫 v-slot:default，很怪 -->
    <!-- <template v-slot:default 應該要包在 suggestionText> -->
    <!-- popover 內容 -->
    <slot name="suggestContent">
    </slot>
    <!-- </template> -->
    <!-- reference 是 el-popover 要用的 slot -->
    <!-- slot="xxx" 是 vue 2.6 前的語法，不知為何這邊不能用新語法 -->
    <template slot="reference">
    <!-- <template v-slot:reference> --><!-- 新語法，但不能用 -->
      <!-- shownElement 是 component 要用的 slot，觸發 popover 用的 element -->
      <slot name="shownElement">
        <!-- 預設是 icon, 除非有給 slot 進來 -->
        <div style="color: #4DA1FF; margin-left: 5px">
          <i class="fas fa-info-circle"></i>
        </div>
      </slot>
    </template>
  </el-popover>
</template>

<script>
export default {
  props: {
    visibleArrow: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'top-start'
    },
    content: {
      type: String
    },
    trigger: {
      type: String,
      default: 'hover'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
